import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { AddWellComponent } from '../addwell/addwell.component';
import { SingleUserComponent } from '../singleuser/singleuser.component';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard  {
    canDeactivate(component: AddWellComponent | SingleUserComponent) {
       // return component.canDeactivate ? component.canDeactivate() : true;
        if (component.hasChanges) {
            return window.confirm('You have unsaved changes. Do you want to leave?');
        }
        return true;
    }
}
